import {AsyncStatusesEnum} from '../../../../../libs/shared/helpers/src/types/asyncStatuses';
import {AppAction} from '../../../appActions';
import {ContactDetailsPanelCreateAccountSubState} from '../../contacts/contactDetailsPanelSubState';
import {ContactsManagerCreateAccountFormState} from '../../contacts/contactsManager/sidePanel/contactsManagerCreateAccountFormState';
import {CreateAccountFormActionsEnum} from './createAccountFormActions';

export function contactsManagerCreateAccountFormReducer(
  state: ContactsManagerCreateAccountFormState,
  action: AppAction,
): ContactsManagerCreateAccountFormState {
  return createAccountFormReducer(state, action) as ContactsManagerCreateAccountFormState;
}

export function contactDetailsCreateAccountFormReducer(
  state: ContactDetailsPanelCreateAccountSubState,
  action: AppAction,
): ContactDetailsPanelCreateAccountSubState {
  return createAccountFormReducer(state, action) as ContactDetailsPanelCreateAccountSubState;
}

export function createAccountFormReducer(
  state: ContactsManagerCreateAccountFormState | ContactDetailsPanelCreateAccountSubState,
  action: AppAction,
): ContactsManagerCreateAccountFormState | ContactDetailsPanelCreateAccountSubState {
  switch (action.type) {
    case CreateAccountFormActionsEnum.UPDATE_NAME: {
      return {
        ...state,
        name: action.payload.name,
      };
    }
    case CreateAccountFormActionsEnum.UPDATE_DESCRIPTION: {
      return {
        ...state,
        description: action.payload.description,
      };
    }
    case CreateAccountFormActionsEnum.UPDATE_AVATAR_FILE: {
      return {
        ...state,
        avatarFile: action.payload.avatarFile,
      };
    }
    case CreateAccountFormActionsEnum.UPDATE_DOMAINS: {
      return {
        ...state,
        domains: action.payload.domains,
      };
    }
    case CreateAccountFormActionsEnum.UPDATE_CUSTOM_ATTRIBUTE: {
      return {
        ...state,
        customAttributes: state.customAttributes.map((customAttribute) =>
          customAttribute.id === action.payload.customFieldId
            ? {...customAttribute, value: action.payload.value}
            : customAttribute,
        ),
      };
    }
    case CreateAccountFormActionsEnum.CREATE_ACCOUNT_STARTED: {
      return {
        ...state,
        createStatus: AsyncStatusesEnum.LOADING,
      };
    }
    case CreateAccountFormActionsEnum.CREATE_ACCOUNT_COMPLETED: {
      return {
        ...state,
        createStatus: AsyncStatusesEnum.LOADED,
      };
    }
    case CreateAccountFormActionsEnum.CREATE_ACCOUNT_FAILED: {
      return {
        ...state,
        createStatus: AsyncStatusesEnum.FAILED,
      };
    }

    default: {
      return state;
    }
  }
}
